export const transformTextToLink = (message: string) => {
  let anchorTagPattern = /<a\s+(?:[^>]*?\s+)?href=["']([^"']*)["'][^>]*>(.*?)<\/a>/i;
  // Check if it already has anchor tags inserted
  if (anchorTagPattern.test(message)) {
    return message;
  }
  // eslint-disable-next-line no-useless-escape
  const regexp = /https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+/g;
  const linking = (url: string) => {
    const matchedLinkReadable = url.length > 41 ? url.substr(0, 40) + "..." : url;
    return `<a href="${url}" target="_blank" style="word-break: break-word;">${matchedLinkReadable}</a>`;
  };
  return message.replace(regexp, linking);
};
